import '../App.css'


export default function Rust() {
    return (
      <h1>Rust</h1>
    
    );
  }